import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { DocumentosUploadModule } from '@usucampeao/ui-mobile';
import { ImoveisDocumentosUploadRoutingModule } from './imoveis-documentos-upload-routing.module';
import { ImoveisDocumentosUploadPage } from './imoveis-documentos-upload.page';


@NgModule({
  declarations: [
    ImoveisDocumentosUploadPage
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,

    // route
    ImoveisDocumentosUploadRoutingModule,

    // components
    DocumentosUploadModule,
  ]
})
export class ImoveisDocumentosUploadPageModule { }
